import { API_BASE } from "../../config/api";
import React from "react";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

/*export function getModalDims(screens) {
  if (!screens.sm) {
    return { width: "92vw", bodyStyle: { maxHeight: "70vh", overflowY: "auto", padding: 16 }, centered: true };
  }
  if (screens.sm && !screens.md) {
    return { width: 480, bodyStyle: { maxHeight: "72vh", overflowY: "auto", padding: 16 }, centered: true };
  }
  return { width: 640, bodyStyle: { maxHeight: "75vh", overflowY: "auto", padding: 16 }, centered: true };
}*/
// BEFORE
// export function getModalDims(screens) {

// AFTER
export function getModalDims(screens = {}) {
  const sm = !!screens.sm; // safe booleans
  const md = !!screens.md;

  if (!sm) {
    return {
      width: "92vw",
      bodyStyle: { maxHeight: "70vh", overflowY: "auto", padding: 16 },
      centered: true,
    };
  }
  if (sm && !md) {
    return {
      width: 480,
      bodyStyle: { maxHeight: "72vh", overflowY: "auto", padding: 16 },
      centered: true,
    };
  }
  return {
    width: 640,
    bodyStyle: { maxHeight: "75vh", overflowY: "auto", padding: 16 },
    centered: true,
  };
}


export function LedgerResponsiveWrapper({ children }) {
  // Never shrink financial data to make a wide table fit a phone.
  // Keep text readable and let the user horizontally scroll / pinch-zoom instead.
  const outer = {
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    touchAction: "pan-x pan-y pinch-zoom",
    padding: 8,
  };

  return <div className="kg-ledger-readable-scroll" style={outer}>{children}</div>;
}

export function mobileAwareColumns(columns) {
  // Preserve every financial column on every screen size. Wide tables scroll horizontally.
  return columns.map((col) => ({
    ...col,
    onCell: () => ({ style: { padding: "6px 8px", fontSize: 14, lineHeight: 1.35, whiteSpace: "nowrap" } }),
    onHeaderCell: () => ({ style: { padding: "6px 8px", fontSize: 14, lineHeight: 1.35, whiteSpace: "nowrap" } }),
    children: Array.isArray(col.children) ? mobileAwareColumns(col.children) : col.children,
  }));
}

export const denseTableProps = {
  size: "small",
  sticky: true,
  scroll: { x: "max-content" },
  pagination: { pageSize: 20, showSizeChanger: false },
  tableLayout: "auto",
  bordered: true,
};

export { API_BASE };
export const getArn = () => localStorage.getItem("arn_number");

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const day = String(d.getDate()).padStart(2, "0");
  const mon = d.toLocaleString("en-US", { month: "short" });
  const year = d.getFullYear();
  return `${day}-${mon}-${year}`;
};

export function rowMatchesSearch(record, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const values = [];
  const collect = (value) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) return value.forEach(collect);
    if (typeof value === "object") return Object.values(value).forEach(collect);
    values.push(String(value).toLowerCase());
  };
  collect(record);
  return values.some((value) => value.includes(q));
}
